import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { NewAssortmentForm } from './newAssortmentForm';
import { useAssortmentTFunction } from '@retail/monitoring-assortment/i18n';
import { TextInput } from '@retail/components';

type Props = Pick<UseFormReturn<NewAssortmentForm>, 'control'>;

const NewAssortmentFields: React.FC<Props> = ({ control }) => {
  const t = useAssortmentTFunction();

  return (
    <TextInput
      control={control}
      name="title"
      label={t('assortment.assortmentName')}
      placeholder={t('assortment.admin.create.form.title.label')}
      fullWidth
      required
    />
  );
};

export default NewAssortmentFields;
